<template>
  <a-popover
    :getPopupContainer="getPopupContainer"
    overlayClassName="consultation_container"
    trigger="click"
    placement="left"
    v-model:visible="visible"
    :align="popoverAlignObj"
  >
    <template #title>
      <div class="input_search">
        <a-input
          class="search"
          v-model:value="searchParams.patientName"
          placeholder="搜索患者姓名"
          allowClear
          :maxlength="19"
          @change="handleSearch"
        >
          <template #prefix>
            <SearchOutlined class="search_icon" />
          </template>
        </a-input>
      </div>
    </template>
    <template #content>
      <a-spin :spinning="loading">
        <!-- 患者价格展示 -->
        <div class="patient_content">
          <!-- 每一个患者序列列表 -->
          <template v-if="indexBarList.length > 0">
            <div class="patient_list" v-for="patientItem in indexBarList" :key="patientItem.key">
              <!-- 顶部序列字母 -->
              <div :id="`select-${patientItem.key}`" class="head">{{ patientItem.key }}</div>
              <!-- 患者诊费详情 -->
              <div
                class="patient_item"
                v-for="patient in patientItem.voList"
                :key="patient.ucPatientId"
              >
                <div class="patient_avatar">
                  <img class="avatar" :src="patient.patientHeadUrl" alt="" />
                </div>
                <div class="patient_description">
                  <div class="patient_info">
                    <div class="name" v-if="patient.patientName">{{ patient.patientName }}</div>
                    <div class="sex" v-if="patient.gender !== null">
                      {{ ['女', '男'][patient.gender] }}
                    </div>
                    <div class="dot" v-if="patient.gender !== null && patient.age !== null">·</div>
                    <div class="age" v-if="patient.age !== null">{{ patient.age }}岁</div>
                  </div>
                  <div class="tip" v-if="patient?.chargeString">
                    <span class="fee">图文咨询</span>
                    <span class="set_price">
                      {{ patient.chargeString }}
                      <!-- {{ handleCharge(patient.chargeStatus, patient.charge) }} -->
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <a-empty v-else class="empty_container" :image="emptyImg">
            <template #description>
              <div class="empty_tip">找不到该患者哦～</div>
            </template>
          </a-empty>
          <!-- 序列索引 -->
          <div class="indexBar_container">
            <a-anchor class="indexBar_content" :getContainer="getContainer">
              <a-anchor-link
                v-for="indexBar in indexBarList"
                :key="indexBar.key"
                :href="`#select-${indexBar.key}`"
                :title="indexBar.key"
              />
            </a-anchor>
          </div>
        </div>
      </a-spin>
    </template>
    <div @click="openPopover" class="current_price_content">
      <!-- 当前患者价格 -->
      <span v-if="currentPrice">当前患者 :{{ currentPrice }}</span>
      <img :src="right" alt="" class="right" />
    </div>
  </a-popover>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, reactive, computed, onMounted } from 'vue'
import { getBindPatientInfoList } from '@/api/chat'
import { SearchOutlined } from '@ant-design/icons-vue'
import { debounce } from 'lodash-es'
import right from '@/assets/img/chat/right.png'
import emptyImg from '@/assets/img/empty.png'
import { formatAmount } from '@/utils'
import { nextTick } from 'vue'
const visible = ref(false)
const indexBarList = ref([])
const loading = ref(false)
const searchParams = reactive({
  ucDoctorId: '',
  patientName: ''
})
const popoverAlignObj = computed(() => {
  return {
    offset: [-160, 0]
  }
})
const props = defineProps({
  currentPrice: {
    type: Number,
    default: null
  },
  ucUserId: {
    type: String,
    default: ''
  },
  isRenderOnParentNode: {
    // 是否渲染在父节点上
    type: Boolean,
    default: false
  }
})
// NOTE:不需要监听弹窗是否关闭，还要去进行请求（只需要打开的时候讲数据清空即可）
// watch(
//   () => visible.value,
//   val => {
//     if (val) {
//       resetConsultationContent()
//     }
//   }
// )
// onMounted(() => {
// getPatientInfoList()
// })

const openPopover = () => {
  searchParams.patientName = ''
  // loading.value = true
  indexBarList.value = []
  // 由于患者列表可能存在，几千条数据所以请求放在下一个事件循环中
  nextTick(() => {
    getPatientInfoList()
  })
}
const getPopupContainer = triggerNode => {
  if (props.isRenderOnParentNode) {
    return triggerNode.parentNode
  }
  return document.body
}
// 重置患者价格内容
// const resetConsultationContent = () => {
// if (searchParams.patientName.trim() !== '') {
// searchParams.patientName = ''
// indexBarList.value = []
// getPatientInfoList()
// }
// }
const getContainer = () => {
  return document.querySelector('.patient_content')
}

// 获取该医生绑定的所有患者信息、诊费
const getPatientInfoList = async () => {
  loading.value = true
  searchParams.ucDoctorId = props.ucUserId
  try {
    const res = await getBindPatientInfoList(searchParams)
    indexBarList.value = res
    nextTick(() => {
      loading.value = false
    })
  } catch (error) {
    loading.value = false
    indexBarList.value = []
  }
}
// 模糊搜索患者信息
const handleSearch = debounce(() => {
  getPatientInfoList()
}, 400)

// chargeStatus: 默认设置的诊费 or 医生设置的诊费，0默认，1医生设置
// const handleCharge = (chargeStatus, charge) => {
//   ;`${chargeStatus === 0 ? '默认' : '医生设置'}${
//     charge === 0 ? '(免费)' : `(${formatAmount(charge)}元/次)`
//   }`
// }
</script>

<style lang="scss">
.consultation_container {
  position: relative;
  min-height: 600px;
  width: 300px;
  // 滚动条样式
  ::-webkit-scrollbar {
    display: none;
  }
  .input_search {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    .search {
      border: none;
      background-color: #f5f7f9;
      border-radius: 4px;
      .ant-input {
        background-color: #f5f7f9;
      }
      .ant-input::placeholder {
        color: #999999;
        font-size: 12px;
      }
      .search_icon {
        color: #999999;
      }
    }
  }

  .patient_content {
    width: 100%;
    height: 550px;

    overflow: scroll;
    .patient_list {
      .head {
        height: 28px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        background-color: #f7f8fa;
      }
      .patient_item {
        display: flex;
        align-items: flex-start;
        background-color: #ffffff;
        padding: 13px 16px 0;
        // height: 74px
        .patient_avatar {
          margin-right: 10px;
          .avatar {
            width: 36px;
            border-radius: 4px;
            height: 36px;
          }
        }
        .patient_description {
          width: calc(100% - 52px);
          padding-bottom: 13px;
          border-bottom: 1px solid #f0f0f0;
          .patient_info {
            display: flex;
            align-items: flex-end;
            .name {
              font-weight: 500;
              margin-right: 8px;
              color: #333333;
            }
            .dot {
              margin: 0 2px;
            }
            .sex,
            .age {
              color: #999999;
              font-size: 12px;
            }
          }
          .tip {
            margin-top: 7px;
            font-size: 12px;
            .fee {
              padding: 2px 5px;
              border: 1px solid #e6e6e6;
              border-radius: 4px 0 0 4px;
              color: #666666;
              line-height: 12px;
            }
            .set_price {
              padding: 2px 5px;
              border-radius: 0 4px 4px 0;
              border: 1px solid #e6e6e6;
              color: #333333;
            }
          }
        }
      }
    }

    .indexBar_container {
      position: absolute;
      right: 5px;
      top: 48px;
      bottom: 0;
      margin: auto;
      width: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .ant-anchor-link {
        padding: 2px 0;
        .ant-anchor-link-title {
          width: 16px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          font-size: 12px;
          color: #808080;
          font-weight: 500;
          border-radius: 50%;
        }
        &.ant-anchor-link-active .ant-anchor-link-title {
          background-color: #3f64ff;
          color: #ffffff;
          border-radius: 50%;
        }
      }
      .ant-anchor-ink::before {
        display: none;
      }
      .ant-anchor-ink-ball.visible {
        display: none;
      }
    }

    .empty_container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: -40px;
      img {
        width: 128px;
        height: 128px;
      }
      .empty_tip {
        font-size: 12px;
        color: #999999;
        margin-top: 24px;
      }
    }
  }
}

.current_price_content {
  min-width: 150px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .right {
    width: 12px;
    height: 12px;
    margin-left: 8px;
  }
}
</style>
